import React from 'react';
import { createRoot } from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19';

import { msalInstance } from '@/auth';
import { App } from './modules/App';

async function bootstrap() {
  // MSAL browser v4 requires initialize before any other API (incl. token for SignalR).
  await msalInstance.initialize();
  createRoot(document.getElementById('root')!).render(<App />);
}

void bootstrap();
